import React from 'react'
import SectionTitle from '../shared/sectionTitle'
import CreateLocationForm from './CreateLocationForm'

const CreateLocationScreen = ({
  id,
  currencies,
  kitchenConfigurationOptions,
  orderProviderOptions,
  dateFormats,
  timeFormats,
  timezones,
  timezoneMappings
}) => {
  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={['New', 'Location']} />
      </div>
      <div className="card card-robis">
        <CreateLocationForm
          id={id}
          currencies={currencies}
          kitchenConfigurationOptions={kitchenConfigurationOptions}
          orderProviderOptions={orderProviderOptions}
          dateFormats={dateFormats}
          timeFormats={timeFormats}
          timezones={timezones}
          timezoneMappings={timezoneMappings}
        />
      </div>
    </>
  )
}

export default CreateLocationScreen
